import { withEventBasedMarketTemplateModelState } from '@swf/sports/models/market-templates/eventBased';

import type { CompetitionEventsState } from './types';

export const defaultState = withEventBasedMarketTemplateModelState<CompetitionEventsState>({
  isLoading: true,
  hasPreloaded: false,
  templateGroups: [],
  showOutrights: false,
  hasInPlayMarkets: false
});
